var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header-button-container",on:{"click":_vm.click}},[_c('FontAwesomeIcon',{staticClass:"icon",style:(_vm.buttonStyle),attrs:{"icon":_vm.icon}}),_c('span',{staticClass:"title",style:(_vm.titleStyle)},[_vm._v(_vm._s(_vm.label))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }